export const onFormatDate = (moment: any) =>
  moment.format('DD MMM YY').toUpperCase();
export const onFormatUTCTime = (moment: any) =>
  `${moment.utc().format('HH.mm.ss')} GMT`;
export const onFormatTime = (moment: any) =>
  `${moment.format('HH.mm.ss')} GMT${moment
    .format('Z')
    .split(':')[0]
    .split('')
    .map((n: any, i: any) => (i === 1 && Number(n) === 0 ? '' : n))
    .join('')}`;

export const minToMillis = (mins) => mins * 1000 * 60;

export const zeroFilledSeconds = (time) => {
  const sec = Math.floor(time / 1000) % 60;
  return sec > 9 ? sec : `0${sec}`;
};
export const zeroFilledMinutes = (time) => {
  const min = Math.floor(time / 1000 / 60);
  return min > 9 ? min : `0${min}`;
};
